import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDiagnosticsWithColorAndContext } from "typescript";
import { setForm, startLoadForm } from "../../actions/formListAction";
import { startLoadProject, startLoadProjects, startLoadProjectSession } from "../../actions/projectAction";
import { setSession } from "../../actions/sessionListAction";
import { useAuth } from "../../contexts/authContext";
import { Form } from "../../models/formModel";
import { AppState } from "../../reducers/rootReducer";
import { getForms, getSession } from "../../selectors/appSelectors";
import DeleteAreaComponent from "../deleteAreaComponent/deleteAreaComponent";
import ElementItemList from "../elementPanel/elementItemList";
import ElementPanelComponent from "../elementPanel/elementPanelComponent";
import PropertyPanelComponent from "../propertyPanel/propertyPanelComponent";
import WorkingPanelComponent from "../workingPanel/workingPanelComponent";
import "./homeComponent.scss"

const HomeComponent = () => {
  const dispatch = useDispatch();
  const [allow, setAllow] = useState(true);
  const [isRefreshed, setisRefreshed] = useState(true);
  const active = useSelector((state: AppState) => state.active);;
  const sessionState = useSelector(getSession);
  const { authData } = useAuth();

  useEffect(() => {
    const session = localStorage.getItem("session");
    if (session && authData && isRefreshed) {
      let sessionObject = JSON.parse(session);
      dispatch(setSession(sessionObject));
      dispatch(startLoadProjects(authData?.userName));
      dispatch(startLoadProjectSession(authData?.userName, `${sessionObject.selectedProjectId}`, `${sessionObject.selectedFormId}`));
    }
    setisRefreshed(false);
  }, [active]);

  return (
    <>
      {allow && (
        <>
        <div className="container-fluid main-container margin-left-zero margin-right-zero">
          <div className="main-wrapper">

              <ElementPanelComponent />

            <div className="working-area">
              <div className="element-item-area"><ElementItemList /></div>
              <div className="working-Panal-Overflow">
                <WorkingPanelComponent />
            </div>

            </div>
            <div className="property-area">
              <PropertyPanelComponent />
              <DeleteAreaComponent />
            </div>
          </div>
        </div>
        </>
      )}
      {!allow && (
        <div className="container-fluid main-container">
          <h5>No Access</h5>
        </div>
      )}
    </>
  );
};

export default HomeComponent;
